import React from 'react';
import styles from './Toggle.module.css';

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  labelPosition?: 'left' | 'right';
  disabled?: boolean;
  size?: 'sm' | 'md';
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  labelPosition = 'right',
  disabled = false,
  size = 'md',
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div
      className={`${styles.container} ${labelPosition === 'left' ? styles.labelLeft : ''}`}
      onClick={handleClick}
    >
      {label && labelPosition === 'left' && (
        <span className={styles.label}>{label}</span>
      )}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        className={`${styles.toggle} ${styles[size]} ${checked ? styles.checked : ''} ${disabled ? styles.disabled : ''}`}
      >
        <span className={styles.thumb} />
      </button>
      {label && labelPosition === 'right' && (
        <span className={styles.label}>{label}</span>
      )}
    </div>
  );
};

export default Toggle;
